module.exports = __webpack_public_path__ + "static/media/iv_referrals.d8f322ed.svg";